import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';

class InlineHintFutureVersionComponentCtrl implements ng.IController {
    private nextGasDay: number;

    constructor(private utilService: UtilService) {}

    $onInit() {
        this.nextGasDay = this.utilService.getNextGasDayStart();
    }
}

angular.module('app').component('pkpInlineHintFutureVersion', {
    controller: InlineHintFutureVersionComponentCtrl,
    template: require('app/shipper-admin/inline-hint-future-version.component.html'),
    bindings: {},
    transclude: true
});
